<template>
    <section class="app-main">
        <div class="top-bar">
            <el-input placeholder="输入商品名称" v-model="keywords"  style="width:300px;margin-right:20px" @change="getData" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button type="success" plain @click="handleAdd">添加关键字</el-button>
        </div>
        <!-- 商品列表 -->
        <div class="content">
            <el-table :data="tableData"  height="630" style="width: 100%" @selection-change="handleChecked">
                <el-table-column type="selection" width="60" align="center"></el-table-column>
                <el-table-column label="商品图片" fixed align="center" width="150">
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.image_url" :src="scope.row.image_url" />
                    </template>
                </el-table-column>
                <el-table-column prop="goods_info.name" label="商品名称"  align="center"  width="300" show-overflow-tooltip></el-table-column>
                <el-table-column prop="name" label="商品状态"  align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 0" style="color:#F56C6C">已下架</span>
                        <span v-else style="color:#67C23A">已上架</span>
                    </template>
                </el-table-column>
                <el-table-column prop="description" label="关键词"  align="center"></el-table-column>
            </el-table>
            <el-pagination background @current-change="loadPage" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </div>
        <el-dialog title="添加关键词" center :visible.sync="dialog" width="600px">
            <el-row class="line-item">
               <el-col :span="4" class="item-label">关键词：</el-col>
               <el-col :span="20">
                   <el-input placeholder="请输入关键词" v-model="title"></el-input>
               </el-col>
            </el-row>
            <el-row type="flex" class="line-item" justify="center">
                <el-col :span="6" style="text-align:center"><el-button :disabled="disabled" type="info" plain @click="dialog = false" style="width:120px">取消</el-button></el-col>
                <el-col :span="6" style="text-align:center"><el-button :disabled="disabled" type="primary" plain @click="handleConfirm" style="width:120px">确定</el-button></el-col>
            </el-row>
        </el-dialog>
    </section>
</template>
<script>

import { search_goods, words_put } from "@/api/goods.js"

import MImg   from '@/components/Image'
export default {
    components: { MImg },
    data() {
        return {
            lang: 'zh', // 语言
            keywords:'',
            page:1,
            total: 0,
            size: 0,
            tableData:[],
            title: '',
            dialog: false,
            disabled: false,
            ids: []
        }
    },
    methods: {
        handleChecked(rows) {
            this.ids = []
            rows.forEach(e => {
                this.ids.push(e.id)
            })
        },
        search() {
            this.page = 1;
            this.getData()
        },
        getData() {
            let params = {
                page: this.page,
                limit: 20
            }
            if(this.keywords != '') {
                params.keywords = this.keywords
            }
            search_goods(params).then(res => {
                if(res) {
                    this.tableData =  res.data.data
                    this.total = res.data.total
                    this.size = res.data.per_page
                }
            })
        },
        loadPage(page){
            this.page = page;
            this.getData()
        },
        handleAdd() {
            if(this.ids.length  == 0) {
                this.$message.error('请选择商品')
                return false
            }
            this.dialog = true
        },
        handleConfirm() {
            if(this.title == '') {
                this.$message.error('请输入关键词')
                return false
            }
            let params = {
                goods_id: this.ids,
                keywords: this.title
            }
            this.disabled = true
            words_put(params).then(res => {
                if(res) {
                    this.$message({type:'success', message: res.msg})
                    this.dialog = false
                    this.getData()
                }
            }).finally(() => {
                this.disabled = false
            })
        },
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    }
}
</script>

<style lang="less" scoped>
/deep/ .el-radio-group {
    margin-right: 20px;
    .el-radio--medium.is-bordered {
        height: 40px;
        padding: 0 10px;
        line-height: 40px;
        margin-right: 10px;
        margin-left: 0;
    }
}
.tables-btns {
    display: flex;
    justify-content: center;
    .el-button {
        margin-right: 5px;
    }
}
.line-item {
    margin-bottom: 20px;
}
.item-label {
    height: 40px;
    line-height: 40px;
}
</style>


